<template>
    <div class="register-wrap">
            <div class="input" v-for="(input, index) in fields" :key="'key-' + input.text">
                <span class="label" v-if="input.type !== 'checkbox'">{{$t('register.' + input.text)}}</span>
                <div class="item" ref="input">
                    <input :type="input.type"
                     :placeholder="$t('register.' + input.text + 'Placeholder')"
                     v-if="input.type !== 'select' && input.type !== 'checkbox'"
                     :name="input.text"
                     @click="handleError(input.text)"
                     v-model="models[input.text]"
                     :class="{error: errors[input.text]}"
                    >
                    <v-select v-if="input.type === 'select'"
                     :options="input.options"
                     class="v-input"
                     @click.native="handleError(input.text)"
                     @input="handleInput($event, input.text)"
                     :class="{error: errors[input.text]}"
                     :placeholder="$t('register.' + input.text + 'Placeholder')"
                    />
                    <div class="reveal-password" @click="handlePassword(index, !input.visible)" v-if="input.type === 'password'">
                        <span class="material-icons">
                            {{input.visible ? 'visibility_off' : 'visibility'}}
                        </span>
                    </div>
                    <input type="checkbox" v-if="input.text === 'terms'" id="terms" @change="handleTerms">
                    <div v-if="input.text === 'terms'"><label for="terms" :class="{error: errors[input.text]}">{{$t('register.agreement')}}</label> <a class="terms" @click="$emit('terms')">{{$t('register.termsPart')}}</a></div>
                    <input type="checkbox" v-if="input.text === 'privacy'" id="privacy" @change="handlePrivacy">
                    <div v-if="input.text === 'privacy'"><label for="privacy" :class="{error: errors[input.text]}">{{$t('register.agreement')}}</label> <a class="terms" @click="$emit('privacy')">{{$t('register.policyPart')}}</a></div>
                </div>
                <small v-if="errors[input.text]">
                    {{$t('register.' + input.text + 'Error')}}
                </small>
            </div>
        <div class="button-wrap">
            <div class="no-acc-text">{{$t('login.alreadyHaveAcc')}} <router-link to="/login">{{$t('login.loginHere')}}</router-link></div>
            <div class="button-round" tabindex="0" @click="handleNext">{{$t(buttonText)}} <span class="material-icons">arrow_right_alt</span></div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
export default {
    components: {
        vSelect
    },
    props: {
        fields: {
            type: Array,
            required: true
        },
        page: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            models: {},
            errors: {}
        }
    },
    computed: {
        buttonText () {
            return this.page ? 'button.register' : 'button.next'
        } 
    },
    mounted () {
        for (let el of this.fields) {
            this.models[el.text] = ''
            this.errors[el.text] = false
        }
    },
    methods: {
        handleNext () {
            let failed = false
            for (const el of this.fields) {
                if (el.validator !== undefined && !el.validator(this.models[el.text])) {
                    this.errors[el.text] = true
                    failed = true
                }
                if (el.matches) {
                    if (this.models[el.matches] !== this.models[el.text]) {
                        this.errors[el.text] = true
                        failed = true
                    }
                }
            }
            if (failed) {
                this.errors = Object.assign({}, this.errors)
                return
            }
            this.$emit('next', this.models)
        },
        handleError (text) {
            this.errors[text] = false
            this.errors = Object.assign({}, this.errors)
        },
        handleInput (val, text) {
            if (val && val.code) {
                val = val.code
            }
            this.models[text] = val
            this.models = Object.assign({}, this.models)
        },
        handlePassword (index, val) {
            let type = val ? 'text' : 'password'
            this.fields[index].visible = val
            this.$refs.input[index].firstChild.type = type
        },
        handleTerms (e) {
            this.models.terms = e.target.checked
            if (this.models.terms) {
                this.errors.terms = false
                this.errors = Object.assign({}, this.errors)
            }
            this.models = Object.assign({}, this.models)
        },
        handlePrivacy (e) {
            this.models.privacy = e.target.checked
            if (this.models.privacy) {
                this.errors.privacy = false
                this.errors = Object.assign({}, this.errors)
            }
            this.models = Object.assign({}, this.models)
        }
    }
}
</script>

<style lang="scss" scoped>
.button-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 50px;
}
.item {
    position: relative;
    display: flex;
    align-items: center;
}
.input {
    margin: 15px 0;
    input,.v-input, label {
        transition: border-color .1s ease;
    }
}
input, .v-input {
    border: transparent 1.5px solid;
    flex-grow: 1
}
input[type=checkbox] {
    flex-grow: unset
}
label {
    border-bottom: transparent 1.5px solid;
}
small {
    display: block;
    color: red;
}
.reveal-password {
    position: absolute;
    top: 57%;
    transform: translateY(-50%);
    right: 6px;
    cursor: pointer;
    user-select: none;
    opacity: .5;
}
.button-round {
    background: var(--button-color-yellow);
}

.terms {
    color: #2E66FF;
}
a {
    cursor: pointer;
    color: #F2BD00;
}
.label {
  margin-left: 15px;
}
.no-acc-text {
  font-size: 0.9em;
  font-weight: 200;
  margin-right: 10px;
}

#terms,
#privacy {
  min-width: 15px;
  min-height: 15px;
}
</style>